import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState, useEffect, useRef, useMemo } from "preact/hooks";
import { facetTypes } from "../config"
import { sortSizeData } from "../helpers"

export default ({ facet, sidebarOpen }) => {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);
    const [ dropdownHeight, setDropdownHeight ] = useState(null);
    const dropdownRef = useRef(null);
    const type = useMemo(() => facetTypes.find(facetType => facetType.facetNames.includes(facet.name))?.type, []);

    useEffect(() => {
        if(facet.name === 'Size' && facet.data?.length > 0) {
            sortSizeData(facet.data)
        }
    }, [ facet ])

    useEffect(() => { // for animating height on expand/collapse
        if(!dropdownHeight && dropdownRef?.current && sidebarOpen) {
            setDropdownHeight(dropdownRef.current.offsetHeight);
        }
    }, [ sidebarOpen, dropdownHeight, dropdownRef, facet ]);

    return (
        <li 
            class={`filter-group
                ${
                    (type === 'boxed')
                        ? 'filter-group--button-grid filter-group--layout-three-column' 
                        : (type === 'color')
                            ? 'filter-group--swatch filter-group--layout-no-label'
                            : 'filter-group--layout-two-column'
                }`
            }
        >
            <button
                class={`filter-group__heading ${active ? 'toggle-target-toggler--is-hidden' : ''}`}
                type="button"
                data-nosto-element="facet"
                aria-controls={`ns-facet-${facet.id}`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
                aria-expanded={active}
                onClick={toggleActive}
            >
                <span class="filter-group__heading__text">
                    {facet.name}
                </span>
                <span class="filter-group__heading__indicator">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                </span>
            </button>
            <div 
                class={`ns-facet-dropdown filter-group__items toggle-target ${active ? 'ns-active' : ''}`} 
                id={`ns-facet-${facet.id}`}
                style={`--dropdown-height: ${dropdownHeight}px;`}
                aria-hidden={!active}
            >
                <ul class="toggle-target-container ns-list-unstyled" role="menu" ref={dropdownRef}>
                    {facet.data?.map(value => (
                        <label
                            key={value.value}
                            class="filter-group__item"
                            data-nosto-element="facet-setting"
                            {...(type === 'color' ? { 'data-swatch': value.value.toLowerCase().replaceAll(' ', '-')} : {} )}
                        >
                            <input
                                class="filter-group__checkbox"
                                type="checkbox" 
                                checked={value.selected} 
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="filter-group__item__text">
                                {value.value}
                                <svg class="filter-tick" role="presentation" viewBox="0 0 20 20">
                                    <path d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"></path>
                                </svg>
                            </span>
                        </label>
                    ))}
                </ul>
            </div>
        </li>
    )
}